module.exports = __webpack_public_path__ + "img/icone_dash.ac97a95c.svg";